<template>
  <div class="addGroupingDialog">
    <el-dialog
      :title="title"
      :visible.sync="open"
      :close-on-click-modal="true"
      width="700px"
      @open="handleOpen"
      :before-close="handleClose"

    >
      <div class="addGrouping-box">
        <el-form
          class="addGrouping-form"
          label-width="130px"
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="分组名称：" prop="groupName">
            <el-input
              class="addGrouping-input"
              v-model="form.groupName"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="就医档案：">
            <div class="Medical-records">
              <el-checkbox v-model="form.medicalRecordRequired" :true-label="1" :false-label="0" @change="checkChange" >必填</el-checkbox>
              <span>( 如勾选为必填，患者端功能权限默认开启 )</span>
            </div>
          </el-form-item>
          <el-form-item label="患者端功能权限：" prop="appletMenuInfosP" >
            <el-tree
              @check="nodeClick"
              :data="patientTreeData"
              show-checkbox
              default-expand-all
              node-key="appletMenuId"
              ref="patientTreeRef"
              :props="defaultProps"
              highlight-current
            >
            </el-tree>
          </el-form-item>
          <!-- v-if="GroupingId" -->
          <el-form-item v-if="id && doctorIds.length > 0" label="分组成员：" >
            <div class="Group-Members">
              <div class="Group-item" v-for="(item, index) in doctorIds" :key="index">
                <div class="left">
                  <img src="@/assets/Grouping/People.png" alt="" />
                  <span>{{ item.docName }}</span>
                </div>
                <img
                  class="right"
                  @click="deleteDoctor(item)"
                  src="@/assets/Grouping/DeleteThree.png"
                  alt=""
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="btn-box">
          <el-button @click="confirm" class="btn" type="primary" :loading="confirmLoading" >确认</el-button>
          <el-button @click="handleClose(cancel)" class="btn">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "addGroupingDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    doctorID: {
      type: String,
      default: () => {
        return "";
      },
    },
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    groupName: {
      type: String,
      default: () => {
        return "";
      },
    },
    status: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    medicalRecordRequired: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    appletMenuInfosP: {
      type: Array,
      default: () => {
        return [];
      },
    },
    groupList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      form: {
        groupName: "",
        medicalRecordRequired: "",
        appletMenuInfosP: [],
      },
      doctorIds: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      rules: {
        groupName: [
          {required: true, message: "请输入分组名称", trigger: "blur"},
          {
            min: 0,
            max: 10,
            message: "*分组名称不可超过10个字，请重新命名",
            trigger: "blur",
          },
          {
            pattern: /^[\u4e00-\u9fa5A-Za-z0-9]{1,10}$/,  // 核心正则
            message: '仅支持中英文、数字，且不超过10个字符',
            trigger: 'blur'
          }
        ],
      },
      patientTreeData: [],
      confirmLoading: false,
    };
  },
  watch: {},
  computed: {
    title() {
      let str = "";
      if (this.GroupingId) {
        str = "编辑分组二维码";
      } else {
        str = "添加分组二维码";
      }
      return str;
    },
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  async created() {

  },
  mounted() {

  },
  methods: {
    async handleOpen() {
      await this.getTree();
      this.$nextTick(() => {
        this.form.groupName = this.groupName;
        this.form.medicalRecordRequired = this.medicalRecordRequired;
        this.form.appletMenuInfosP = this.appletMenuInfosP;
        this.doctorIds = this.groupList;
        this.$refs.patientTreeRef.setCheckedKeys(this.appletMenuInfosP);
        this.checkChange(this.medicalRecordRequired);
      })
    },
    getTree() {
      return new Promise((resolve) => {
        this.$get("am/getappletmenuinfo").then((res) => {
          console.log(res);
          let data = res.data;
          this.patientTreeData = data.appletMenuInfosP;
          resolve();
        });
      });
    },
    checkChange(e) {
      if (e === 1) {
        const arr = this.$refs.patientTreeRef.getCheckedKeys();
        this.$refs.patientTreeRef.setCheckedKeys([...arr,'2']);
      }
    },
    deleteDoctor(e) {
      this.doctorIds = (this.doctorIds || []).filter((item) => item.docId !== e.docId);
    },
    confirm() {
      console.log(this.$refs.patientTreeRef.getCheckedKeys());
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.appletMenuInfosP = this.$refs.patientTreeRef.getCheckedKeys();
          this.confirmApi({
            docId: this.doctorID,
            groupId: this.id,
            status: this.status,
            doctorIds: (this.doctorIds || []).map((item) => item.docId),
            ...this.form,
          })
        } else {
          return false;
        }
      });
      // this.open = false;
    },
    async confirmApi(e) {
      try{
        this.confirmLoading = true;
        const res = await this.$post("group/add", e);
        if (!res) {
          this.confirmLoading = false;
          return false
        }
        // eslint-disable-next-line no-unused-vars
        const { data } = res;
        console.log(res);
        this.$emit("confirm");
        this.confirmLoading = false;
        this.open = false;
        /*this.$message({
          type: "success",
          message: "操作成功！",
        });*/
      }catch (e) {
        console.error(e);
      }
    },
    cancel() {
      this.open = false;
    },
    nodeClick(node) {
      console.log(node);

      // console.log(this.$refs.patientTreeRef.getCheckedKeys());
      let str = node.appletMenuId;
      let arr = this.$refs.patientTreeRef.getCheckedKeys();
      console.log(arr,`arr`);
      if(!arr.includes("2")){
        this.form.medicalRecordRequired=''
      }
      if (str == "16") {
        if (arr.includes("3")) {
          console.log("包含16");
          this.$refs.patientTreeRef.setChecked(3, false);
          arr.forEach((item, index) => {
            if (item == "3") {
              arr.splice(index, 1);
            }
          });
          console.log(arr);

          this.$refs.patientTreeRef.setCheckedKeys(arr);
        }
      } else if (str == "3") {
        if (arr.includes("16")) {
          console.log("包含3");
          this.$refs.patientTreeRef.setChecked(16, false);
          arr.forEach((item, index) => {
            if (item == "16") {
              arr.splice(index, 1);
            }
          });
          console.log(arr);

          this.$refs.patientTreeRef.setCheckedKeys(arr);
        }
      }
    },
    handleClose(done) {
      this.$refs.patientTreeRef.setCheckedKeys([]);
      this.$refs.ruleForm.resetFields();
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.addGroupingDialog {
  .addGrouping-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .addGrouping-form {
      width: 480px;
      .addGrouping-input {
        width: 280px;
        margin-left: 23px;
      }
      .Medical-records {
        margin-left: 23px;
      }
      .Group-Members {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        .Group-item {
          display: flex;
          justify-content: space-between;
          background-color: rgb(242, 246, 255);
          align-items: center;
          border-radius: 2px;
          padding: 0 20px;
          .left {
            display: flex;
            align-items: center;
            gap: 10px;
            img {
              width: 18px;
              height: 18px;
            }
            span {
              font-size: 16px;
              color: #005dba;
            }
          }
          .right {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      border-top: 1px solid #ebecf0;
      width: 100%;
      padding-top: 25px;
      .btn {
        width: 90px;
        height: 36px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
::v-deep .el-dialog__header {
  background-color: #1a7cf2;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
::v-deep .el-form-item__error{
  margin-left: 23px;
}
</style>
